export interface TeacherSchedule {
  sectionData: SectionData;
  course: Course;
}

export type TeacherScheduleList = TeacherSchedule[];

export interface Course {
  id: number;
  name: string;
  code: string;
  shortening: string;
  credits: number;
  totalHours: number | null;
  schoolId: number;
  academicLevelId: number;
  modalityId: number | null;
  syllabusId: null;
  createdAt: Date;
  updatedAt: Date;
  replaceCourseGradeAllowed: boolean;
  replaceEvaluationGradeAllowed: boolean;
  isEnable: boolean;
  types: Types;
}

export interface Types {
  id: number;
  name: string;
  priority: number;
  generalTypeId: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface SectionData {
  id: number;
  name: string;
  maximumStudent: number;
  courseId: number;
  scheduleId: number | null;
  periodId: number;
  moodleSectionId: null;
  createdAt: Date;
  updatedAt: Date;
  structureTypeSchemaId: number;
  structureTypeId: number;
  academicLevelId: number;
  campusId: number;
  closedAt: null;
  closedWithId: null;
  sectionSchedules: SectionSchedule[];
  professors: Professor[];
  campus: Campus;
}

export interface Campus {
  id: number;
  code: string;
  name: string;
  addressStreet: string;
  addressNumber: string;
  addressExtra: string | null;
  communeId: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface Professor {
  id: number;
  account: Account;
}

export interface Account {
  id: number;
  name: string;
  paternalLastName: string;
  maternalLastName: string;
  paternalPreference: boolean;
  fullName: string;
}

export interface SectionSchedule {
  id: number;
  day: string;
  startDate: Date;
  endDate: Date;
  type: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: null;
  activityId: number;
  modalityId?: number;
  classroom: Activity;
  activity: Activity;
  modality?: Modality;
  startModule: Module;
  endModule: Module;
}

export interface Activity {
  id: number;
  name: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface Module {
  id: number;
  name: string;
  shortening: string;
  startTime: string;
  endTime: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface Modality {
  id: number;
  name: string;
  code: string;
  deliveryMode: ModalityCodesEnum;
  description: string;
  isClassroomRequired: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

export enum ModalityCodesEnum {
  PR = 'PR', // Presencial
  SP = 'SP', // Semi-presencial
  OL = 'OL', // Online
  DI = 'DI', // Distancia
  DU = 'DU', // Dual
}

export enum SectionScheduleTypeEnum {
  Default = 'default',
  Recovery = 'recovery',
}

export type sectionListType = {
  sectionName: string;
  courseName: string;
  teachers: string[];
  schedules: {
    day: string;
    classroom: string;
    startHour: string;
    endHour: string;
  }[];
};
